<template>
  <div>
    <div class="item">
    	<span class="item-title">业务员名称:</span>
    	<span>{{detailInfo.user_name}}</span>
    </div>
    <div class="item">
    	<span class="item-title">申请时间:</span>
    	<span>{{detailInfo.create_time}}</span>
    </div>
    <div class="item">
    	<span class="item-title">提现金额(元):</span>
    	<span>{{detailInfo.amount}}</span>
    </div>
    <div class="item">
    	<span class="item-title">卡号:</span>
    	<span>{{detailInfo.bank_info.bank_code}}</span>
    </div>
    <div class="item">
    	<span class="item-title">姓名:</span>
    	<span>{{detailInfo.bank_info.user_identity_card_name}}</span>
    </div>
    <div class="item">
    	<span class="item-title">身份证:</span>
    	<span>{{detailInfo.bank_info.user_identity_card_no}}</span>
    </div>
    <div class="item">
    	<span class="item-title">手机号:</span>
    	<span>{{detailInfo.bank_info.user_mobile}}</span>
    </div>
    <div class="item">
    	<span class="item-title">状态:</span>
    	<el-select v-model="status_now" placeholder="请选择状态" v-if="detailInfo.status === '1'">
		    <el-option
		      v-for="item in options"
		      :key="item.type"
		      :label="item.label"
		      :value="item.type"
		      :disabled="item.disabled">
		    </el-option>
		  </el-select>
    	<span v-if="detailInfo.status === '2'">已通过</span>
    	<span v-if="detailInfo.status === '3'">已拒绝</span>
    </div>
    <div class="item" v-if="detailInfo.status === '3'">
    	<span class="item-title">拒绝原因:</span>
    	<span>{{detailInfo.reasons_for_refusal}}</span>
    </div>
    <div class="item" v-if="detailInfo.status !== '3' && status_now === '3'">
      <span class="item-title">拒绝原因:</span>
      <el-input
			  type="textarea"
			  :rows="3"
			  placeholder="请输入原因"
			  v-model="refuse_reason"
			  class="resue_reason_input"
			>
			</el-input>
    </div>
    <div class="btn-wrap">
    	<el-button type="primary" v-if="detailInfo.status === '1'" @click="submitClick">提交</el-button>
    	<el-button type="primary" @click="backBtnClick">返回</el-button>
    </div>
  </div>
</template>

<script>
import { withdrawDetail, withdrawStatusChange } from '@/api/finance-manage';

export default {
  name: 'withdrawdetail',
  data() {
  	return {
      detailInfo: {
      	bank_info: {
      		bank_code: ''
      	}
      },
      status_now: '',
      refuse_reason: '',
      options: [
        { type: '1', label:'待审核'},
        { type: '2', label:'已通过'},
        { type: '3', label:'已拒绝'}
      ]
  	}
  },
  mounted() {
  	this.getWithdrawDetail(this.$route.query.uuid);
  },
  methods: {
    async getWithdrawDetail(uuid) {
   	  const { status, data } = await withdrawDetail(uuid);
   	  if (status !== 200) return
   	  	console.log(data, 'detail')
   	  this.detailInfo = data;
   	  this.status_now = data.status;
    },
    async submitClick() {
    	if (this.status_now === '1') {
    		this.$message('目前已是待审核，请选择其他状态再提交');
    		return
    	}
    	if (this.status_now === '3' && !this.refuse_reason) {
        this.$message('请输入拒绝理由');
    		return
    	}
    	let postData;
    	if (this.status_now === '2') {
    		postData = {
          status: this.status_now
    		}
    	}
    	if (this.status_now === '3') {
    		postData = {
    			status:  this.status_now,
    			reasons_for_refusal: this.refuse_reason
    		}
    	}
    	const { status } = await withdrawStatusChange(postData, this.detailInfo.uuid);
    	if (status === 200) this.$router.go(-1)
    },
    backBtnClick() {
    	this.$router.go(-1);
    }
  }
}
</script>

<style lang="less" scoped>
.item {
	display: flex;
	align-items: center;
	margin-right: 100px;
	margin-bottom: 30px;
	.item-title {
		width: 95px;
		margin-right: 30px;
		font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153,153,153,1);
	}
	.resue_reason_input {
		width: 300px;
	}
}
.btn-wrap {
	text-align: center;
	margin: 30px auto;
}
</style>
